import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Badge } from '@/components/ui/badge'
import { OdinIcon } from '@/components/ui/odin/odin-icon'
import { cn } from '@/lib/utils'

export type OdinStatusBadgeVariant = 'info' | 'positive' | 'negative'

const VARIANT_CLASSES: Record<OdinStatusBadgeVariant, string> = {
  info: 'bg-primary/10 text-primary',
  positive: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
  negative: 'bg-destructive/10 text-destructive',
}

type OdinStatusBadgeProps = {
  variant: OdinStatusBadgeVariant
  icon?: IconProp
  label?: string
  /** Icon-only circular badge instead of a label pill. */
  circle?: boolean
  className?: string
}

// Small semantic status badge (light tint + strong ink) on the shadcn Badge. Reusable across the widget.
export const OdinStatusBadge = ({ variant, icon, label, circle, className }: OdinStatusBadgeProps) => {
  return (
    <Badge
      className={cn(
        'border-transparent font-bold',
        circle && 'size-6 rounded-full p-0',
        VARIANT_CLASSES[variant],
        className,
      )}
    >
      {icon && <OdinIcon icon={icon} />}
      {!circle && label}
    </Badge>
  )
}
